exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel-body .item-parameter{margin:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules?sourceMap!./vendor/sections/catalog/catalog-list.useable.css
// module id = 744
// module chunks = 0